import type { AdminUserRecord } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminUsersApi = {
  getAll: (workspaceId?: string): Promise<AdminUserRecord[]> =>
    adminApiGet<AdminUserRecord[]>(
      workspaceId
        ? `/users?workspace_id=${encodeURIComponent(workspaceId)}`
        : "/users",
    ),

  getById: (id: string): Promise<AdminUserRecord> =>
    adminApiGet<AdminUserRecord>(`/users/${id}`),
};
